import Typography from '@mui/material/Typography'

export const FreeLabel = () => {
    return (
        <Typography
            component="p"
            variant="caption2"
            sx={{
                height: '20px',
                textAlign: 'center',
                width: '44px',
                fontWeight: '600',
                background: '#006CFD',
                color: '#fff',
                alignItems: 'center',
                padding: '2px 6px',
                borderRadius: '8px',
            }}>
            FREE
        </Typography>
    )
}
